// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import App from './App'
import router from './router'
import moment from 'moment';
import Vuex from 'vuex';
import axios from 'axios'
import VueAxios from 'vue-axios'
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
import '@/utils/flexible'
import { Toast } from 'mint-ui';
import 'mint-ui/lib/style.css'
import VueEsign from 'vue-esign';
import '@/assets/scss/index.scss'
Vue.use(VueEsign);
import SignCanvas from '@/components/SignCanvas'
Vue.component('SignCanvas', SignCanvas)
Vue.$toast = Vue.prototype.$toast = Toast;
// 本地化，中文时间显示
moment.locale('zh-cn');

Vue.prototype.moment = moment;

Vue.prototype.random = n => Math.floor(n * Math.random());
import wx from 'weixin-js-sdk'
Vue.use(wx)

import VideoPlayer from 'vue-video-player';
import "videojs-flash";
require('video.js/dist/video-js.css')
require('vue-video-player/src/custom-theme.css')
// require('videojs-contrib-hls/dist/videojs-contrib-hls.js')
Vue.use(VideoPlayer)
import 'videojs-contrib-hls';

// Vuex
Vue.use(Vuex);
Vue.use(ElementUI);
// axios
Vue.use(VueAxios, axios);

const store = new Vuex.Store({
  state: {
    name: '',
    // avatarUrl: `https://icdn.microzz.com/20170426_vue_chat/icon-avatar${Vue.prototype.random(21)}.svg`,
    avatarUrl: `http://omratag7g.bkt.clouddn.com/icon-avatar${Vue.prototype.random(21)}.svg`,
    addr: '未知',
    isShowAbout: false
  },

  mutations: {
    changeName(state, name) {
      state.name = name;
    },
    setAddr(state, addr) {
      state.addr = addr;
    },
    showAbout(state, flag) {
      state.isShowAbout = flag;
    }
  }
});

Vue.config.productionTip = false

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js